$(document).on('input click', '.js-dropdown-sort-by-equal', function () {
  let val = $(this).val().toLowerCase(),
    target = $(this).attr('data-sort'),
    inputId = $(this).attr('id');
  $('#' + target)
    .find('.form-item-dropdown__item')
    .each(function () {
      $(this)
        .addClass('js-dropdown-sort-by-equal-item')
        .attr('data-target-input', inputId);
      let itemValue = $(this).text().toLowerCase();
      if (!itemValue.includes(val) || val == '') {
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
      }
    });

  if ($('#' + target).find('.form-item-dropdown__item.active').length) {
    $('#' + target).addClass('active');
  } else {
    $('#' + target).removeClass('active');
  }
});
$('.js-dropdown').on('click', '.js-dropdown-sort-by-equal-item', function () {
  let val = $(this).text(),
    targetInput = $(this).attr('data-target-input');
  $('#' + targetInput).val(val);
  $(this).closest('.js-dropdown').removeClass('active');
  $(this)
    .siblings()
    .each(function () {
      $(this).removeClass('active');
    });
});
